module.exports = __webpack_public_path__ + "img/maya-analitico.5e317293.png";